import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Modal } from "../../common/Modal";
import { Document } from "../types";

interface DocumentViewerProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectedDocument: Document | null;
  documentUrl: string | null;
}

const DocumentViewer: React.FC<DocumentViewerProps> = ({
  openModal,
  setOpenModal,
  selectedDocument,
  documentUrl,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Modal
      fullScreen={isMobile}
      headerCloseButton={true}
      actions={false}
      open={openModal}
      setOpen={setOpenModal}
      title={selectedDocument?.fileName || ""}
      size="xl"
      onClose={() => setOpenModal(false)}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          width: "100%",
          height: "80vh",
          overflow: "hidden",
        }}
      >
        {documentUrl && (
          <img
            src={documentUrl}
            alt={selectedDocument?.fileName}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
              display: "block",
            }}
          />
        )}
      </Box>
    </Modal>
  );
};

export default DocumentViewer;
